import React, { useState, useEffect } from 'react'
import get from 'lodash/get'
import {
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useStore,
  Create,
  SimpleForm,
  useNotify,
  useRedirect,
  FormDataConsumer,
} from 'react-admin'
import { Container, Chip, Divider, Grid, Box, AlertTitle, Button, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { setResourceProps } from 'src/helper/resourceProps'
import { paymentServices } from 'src/services/payment/Payment.service'
import { Typography } from '@mui/material'
import { PaymentTypeArray } from 'src/components/pages/payment/payment/logic/PaymentTypeArray'
import { CreditArray } from 'src/components/pages/payment/payment/logic/CreditArray'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { FormDivider } from 'src/components/uiElements/fields/Divider'
import { CustomAlert } from 'src/components/uiElements/styledComponents/CustomAlert'
import InfoIcon from '@mui/icons-material/Info'
import { currencyServices } from 'src/services/payment/currency/currency.service'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { useErrorHandler } from 'src/hooks/useErrorHandler'
const TotalByCurrency = () => {
  const [totalByCurrencyLoading, setTotalByCurrencyLoading] = useState(false)
  const [totalByCurrency, setTotalByCurrency] = useState([])
  const { itemsSelected } = usePaymentContext()
  const translate = useTranslate()

  useEffect(() => {
    getTotals(itemsSelected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsSelected])

  const getTotals = async (items) => {
    try {
      setTotalByCurrencyLoading(true)
      const total = await currencyServices.getTotalByCurrency(items)
      if (total && total?.total_by_currency) {
        setTotalByCurrency(total?.total_by_currency)
      }
      setTotalByCurrencyLoading(false)
    } catch (error) {
      setTotalByCurrencyLoading(false)
    }
  }
  return (
    <Box className='subtotals_resume_payment_method'>
      <Box className='subtotals_resume_payment_method_container'>
        {totalByCurrencyLoading
          ? [...Array(5)].map((_, index) => (
              <div className='subtotal_item' key={index}>
                <div className='total_title'>
                  <Skeleton variant='rectangular' width={'100%'} height={20} />
                </div>
                <span className='total_value'>
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                </span>
              </div>
            ))
          : totalByCurrency.map((data, index) => (
              <div className='subtotal_item' key={index}>
                <span className='total_title'>
                  {translate('ra.message.total_payment_in')} {data?.long_name}
                </span>
                <span className='total_value'>
                  {data?.symbol} {numberFormatterWithDecimalAndThousand(data?.amount)}
                </span>
              </div>
            ))}
      </Box>
    </Box>
  )
}

function PaymentList() {
  const notify = useNotify()
  const redirect = useRedirect()
  const translate = useTranslate()
  const showError = useErrorHandler()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [totalAmount, setTotalAmount] = useState(0)
  const [payload, setPayload] = useState(null)
  const [itemTotalAmount, setItemTotalAmount] = useState(0)
  const [restAmount, setRestAmount] = useState(0)
  // const [currencies] = useStore('payment_currencies', [])
  // const [selectedData] = useStore('payment_generate', [])
  const [credit] = useStore('payment_credit')
  // const [selectedItem, setSelectedItem] = useStore('items_selected', [])
  const [loadingModalButton, setLoadingModalButton] = useState(false)
  const [openCustomAlertCredit, setOpenCustomAlertCredit] = useState(false)
  const [openCustomAlertPaymentType, setOpenCustomAlertPaymentType] = useState(false)
  // const [totalByCurrency, setTotalByCurrency] = useState([])
  // const [totalByCurrencyLoading, setTotalByCurrencyLoading] = useState(false)

  const { itemsSelected, setItemsSelected, paymentCurrecies, paymentDate } = usePaymentContext()
  setResourceProps(useResourceDefinitions(), useResourceContext())

  useEffect(() => {
    ;(async () => {
      try {
        if (confirm && payload) {
          setLoadingModalButton(true)
          await onSuccess(payload)
          setOpen(false)
          setLoadingModalButton(false)
        }
      } catch (error) {
        setLoadingModalButton(false)
        notify('ra.notification.created_error_femenine', {
          type: 'error',
          messageArgs: { element: translate('ra.single_entity.payment-entity') },
        })
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  // useEffect(() => {
  //   getTotals(itemsSelected)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [itemsSelected])

  // const getTotals = async (items) => {
  //   try {
  //     setTotalByCurrencyLoading(true)
  //     const total = await currencyServices.getTotalByCurrency(items)
  //     if (total && total?.total_by_currency) {
  //       setTotalByCurrency(total?.total_by_currency)
  //     }
  //     setTotalByCurrencyLoading(false)
  //   } catch (error) {
  //     setTotalByCurrencyLoading(false)
  //   }
  // }

  const handleDelete = (id) => {
    let removeItem = itemsSelected.filter((item) => item.id != id)
    // setSelectedItem(removeItem)
    setItemsSelected(removeItem)
  }

  const amountInPesosArgentinos = (values, hash_currency = false, amount_variable = 'amount_to_pay') => {
    return values.reduce((acc, current) => {
      // const currency = paymentCurrecies.find(
      //   (elem) =>
      //     (hash_currency ? elem?.currency_relation?.hash_currency : elem?.currency_relation?.id) ===
      //     (hash_currency ? current?.currency : current?.currency?.id)
      // )
      const currency = paymentCurrecies.find((elem) => elem?.currency_to_relation?.short_name === 'ARS')
      if (currency) {
        const fixedValue = parseFloat((get(current, amount_variable) * currency.value)?.toFixed(2))
        return acc + fixedValue
      }
      return acc
    }, 0)
  }

  const isMatchAmountPaymentTypeWithItemAmount = (values, setOpen) => {
    let item_amount = amountInPesosArgentinos(itemsSelected)
    let payment_type_amount = amountInPesosArgentinos(values?.paymentType, true)
    let credit_amount = amountInPesosArgentinos(values?.credit, true)

    let sum_credit_and_payment_type = payment_type_amount + credit_amount

    const isLessThan = sum_credit_and_payment_type < item_amount
    const isEqual = sum_credit_and_payment_type == item_amount
    const isGreaterThan = sum_credit_and_payment_type > item_amount

    if (isEqual) return true
    if (isGreaterThan) {
      setTotalAmount(sum_credit_and_payment_type)
      setItemTotalAmount(item_amount)
      setRestAmount(
        (sum_credit_and_payment_type - item_amount).toLocaleString('es-ES', {
          minimumFractionDigits: 2,
        })
      )
      setOpen(true)
      return false
    }
    if (isLessThan) {
      notify(translate('ra.message.unmatch_amount_to_pay'), {
        type: 'error',
      })
      return false
    }
  }

  const isExtraCostCalculated = (values) => {
    if (values?.paymentType) {
      return values.paymentType.every(
        (payment) => payment.extra_cost && payment.extra_cost.every((item) => item.success)
      )
    }
    return false
  }

  const onSuccess = async (payload) => {
    try {
      const response = await paymentServices.liquidateExpenses(payload)
      if (response){
        showError(response, () =>
          notify('ra.notification.created_success_femenine', {
            type: 'success',
            messageArgs: { element: translate('ra.single_entity.payment-entity') },
          })
        )
      }
      redirect('/payment-entity')
    } catch (error) {
      showError(error, () =>
        notify('ra.notification.created_error_femenine', {
          type: 'error',
          messageArgs: { element: translate('ra.single_entity.payment-entity') },
        })
      )
    } 
  }

  const handleSubmit = async (values) => {
    try {
      if (!isExtraCostCalculated(values)) {
        notify('ra.notification.check_extra_cost', {
          type: 'error',
        })
        return
      }
      let trasnform = {
        ...values,
        hash_business_unit: paymentDate?.selectedBusinessUnit?.hash_business_unit,
        item: itemsSelected,
        amount: itemsSelected.reduce((acc, item) => acc + parseFloat(item.amount_to_pay), 0),
      }
      setPayload(trasnform)
      if (isMatchAmountPaymentTypeWithItemAmount(values, setOpen)) {
        // await onSuccess(trasnform)
      }
    } catch (error) {
      showError(error, () =>
        notify('ra.notification.created_error_femenine', {
          type: 'error',
          messageArgs: { element: translate('ra.single_entity.payment-entity') },
        })
      )
    }
  }

  const getSubtotals = (data) => {
    const currenciesTo = paymentCurrecies
      .map((currency) => currency.currency_to_relation)
      .filter(
        (currency, index, self) => index === self.findIndex((c) => c.short_name === currency.short_name)
      )

    const subtotals = currenciesTo?.map((currency) => ({
      currency: currency?.short_name,
      hash: currency?.hash_currency,
      symbol: currency?.symbol,
      value: 0,
    }))
    data.forEach((elem) => {
      const index = subtotals.findIndex((subtotal) => subtotal.hash === elem.currency)
      if (index > -1) {
        const extraCostValue = Array.isArray(elem.extra_cost)
          ? elem.extra_cost.reduce((total, item) => total + (item.value || 0), 0)
          : (elem.extra_cost && elem.extra_cost.value) || 0
        subtotals[index].value += elem.amount_to_pay + extraCostValue
      }
    })
    return subtotals
  }

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.payment-entity')}>
        {itemsSelected.length != 0 && (
          <div className='item_selected_container'>
            <Typography variant='h5' component='h2'>
              {translate('ra.title.item_selected')}
            </Typography>
            <div className='item_selected' component='span' color='text.primary'>
              {itemsSelected?.map((item) => (
                <Chip
                  style={{ margin: '5px' }}
                  sx={{
                    '& .MuiChip-deleteIcon': {
                      color: 'red',
                    },
                  }}
                  key={item.id}
                  label={`Nro: ${item.reservation_number || ''} - Item id: ${item.id} - Producto: '${
                    item.product
                  }' - Monto: $${numberFormatterWithDecimalAndThousand(item.amount_to_pay)} - Moneda: ${
                    item?.currency?.short_name || ''
                  }`}
                  variant='outlined'
                  onDelete={itemsSelected?.length === 1 ? null : () => handleDelete(item.id)}
                />
              ))}
            </div>
          </div>
        )}
        {
          <>
            <Create actions={null}>
              <SimpleForm onSubmit={handleSubmit}>
                <TotalByCurrency />
                {credit?.length !== 0 && (
                  <Grid item sm={12}>
                    <CustomAlert
                      setOpenCustomAlert={setOpenCustomAlertCredit}
                      openCustomAlert={openCustomAlertCredit}
                    >
                      <AlertTitle>Creditos a favor</AlertTitle>
                      Usted tiene creditos a favor los cuales puede utilizar para pagar{' '}
                      <strong>parte del monto</strong> o el <strong>monto total</strong>.<br />
                      Dentro del campo <strong>Importe Total </strong> le dira cuanto es su credito a favor y
                      en el campo
                      <strong> importe a utilizar </strong> podra ingresar la cantidad de credito a favor que
                      quiere utilizar.
                      <br />
                    </CustomAlert>
                  </Grid>
                )}
                <Box className='divider_and_button_container'>
                  <Box className='divider_and_button_container_button'>
                    <Button
                      endIcon={<InfoIcon />}
                      disabled={openCustomAlertCredit}
                      variant='text'
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => {
                        setOpenCustomAlertCredit(true)
                      }}
                    />
                  </Box>
                  <Box className='divider_and_button_container_divider'>
                    <FormDivider flex={7} show={true} text='Creditos a Favor' />
                  </Box>
                </Box>
                <CreditArray />

                <Grid item sm={12}>
                  <CustomAlert
                    setOpenCustomAlert={setOpenCustomAlertPaymentType}
                    openCustomAlert={openCustomAlertPaymentType}
                  >
                    <AlertTitle>{translate('ra.field.payment_types')}</AlertTitle>
                    {translate('ra.message.instructive_paymen_type')}
                  </CustomAlert>
                </Grid>
                <Box className='divider_and_button_container'>
                  <Box className='divider_and_button_container_button'>
                    <Button
                      endIcon={<InfoIcon />}
                      disabled={openCustomAlertPaymentType}
                      variant='text'
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => {
                        setOpenCustomAlertPaymentType(true)
                      }}
                    />
                  </Box>
                  <Box className='divider_and_button_container_divider'>
                    <FormDivider flex={7} show={true} text='Tipos de pago' />
                  </Box>
                </Box>
                <PaymentTypeArray />
                <Box style={{ width: '100%', height: '30px', margin: '40px 0 0 0' }}>
                  <Divider />
                </Box>
                <FormDataConsumer>
                  {({ formData }) => {
                    return getSubtotals(
                      formData?.paymentType && formData?.credit
                        ? [...formData?.paymentType, ...formData?.credit]
                        : []
                    ).map((subtotal, index) => (
                      <div className='subtotals_resume_payment_method' key={index}>
                        <div className='subtotals_resume_payment_method_container'></div>
                        <div className='subtotal_item'>
                          <div className='subtotal_title'>
                            Total con costos adicionales incluidos en {subtotal.currency}
                          </div>
                          <span className='total_value'>
                            {subtotal.symbol} {numberFormatterWithDecimalAndThousand(subtotal.value, 4)}
                          </span>
                        </div>
                      </div>
                    ))
                  }}
                </FormDataConsumer>

                <ConfirmationDialog
                  title={translate('ra.title.credit_in_favor')}
                  contentText={translate('ra.message.credit_in_favor_message', {
                    total_amount: totalAmount,
                    item_total_amount: itemTotalAmount,
                    rest_amount: restAmount,
                    type_currency: 'ARS',
                  })}
                  buttonConfirmText={translate('ra.action.to_confirm')}
                  buttonCancel={translate('ra.action.cancel')}
                  setOpen={setOpen}
                  setConfirm={setConfirm}
                  open={open}
                  loadingModalButton={loadingModalButton}
                />
              </SimpleForm>
            </Create>
          </>
        }
      </CardCommon>
    </Container>
  )
}

export default PaymentList
